import AuthenticationLayout from 'components/AuthLayout';
import { FC } from 'react';
import MenteeChart from './MenteeChart';

const SignChart: FC = () => {
  return (
    <AuthenticationLayout
      title="Signature de la charte (3/3)"
      backTo="/mentee/fill-profile"
      src_image="/logo_institut_mentorat.png"
    >
      <MenteeChart />
    </AuthenticationLayout>
  );
};

export default SignChart;
